module.exports = __webpack_public_path__ + "img/threads.6b0aadd9.svg";